import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { GET, POST } from "../../../services/api";
import { apiUrl } from "../../../ApiHelper/ApiUrl";

export const getControls = createAsyncThunk(
    "control/getControls",
    async (projectId, { rejectWithValue }) => {
        try {
            // const projectId = localStorage.getItem('selectedProject');
            
            const response = await GET(
                "project", 
                `${apiUrl.create_project}/${projectId}/controls`
            );

            return response?.data;
        } catch (error) {
            console.log("##error", error?.detail?.message || error?.message || "Something Went Wrong");
            return rejectWithValue(
                error?.detail?.message || error?.message || "Something Went Wrong"
            );
        }
    }
);

const controlSlice = createSlice({
    name: "controls",
    initialState: {
        data: [],
        loading: false,
        error: null,
    },
    reducers: {
    },
    extraReducers: (builder) => {
        builder
            .addCase(getControls.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getControls.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload?.data;
            })
            .addCase(getControls.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    }
});

export default controlSlice.reducer;